export const messages = Object.assign(
    {
        emailValidationError: "Please provide a valid business email address",
        recaptchaDisclaimer:
            "This site is protected by reCAPTCHA and the Google <a href='https://policies.google.com/privacy' target='_blank'>Privacy Policy</a> and <a href='https://policies.google.com/terms' target='_blank'>Terms of Service</a> apply.",
    },
    typeof mktoMessages !== "undefined" ? mktoMessages : {}
);
